import { ChevronUp, RefreshCw } from 'lucide-react';
import MessageItem from './MessageItem';
import { MessageWithStatus } from '../../../../../Api/sav-v2/savV2MessagesApi';

export type MessageThreadVariant = 'default' | 'internal';

interface MessageThreadProps {
  messages: MessageWithStatus[];
  currentUserId: string;
  onLoadMore?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
  onAttachmentClick?: (attachmentId: number) => void;
  isBeneficiaryView?: boolean;
  variant?: MessageThreadVariant;
}

export default function MessageThread({
  messages,
  currentUserId,
  onLoadMore,
  hasMore = false,
  loadingMore = false,
  onAttachmentClick,
  isBeneficiaryView = false,
  variant = 'default'
}: MessageThreadProps) {

  // flex-col-reverse sur le conteneur scrollable fait automatiquement le scroll en bas
  // Plus besoin de useEffect ou de ref pour forcer le scroll !

  const bgClass = variant === 'internal' ? 'tw-bg-indigo-50' : 'tw-bg-gray-50';

  return (
    <div
      className={`tw-flex-1 tw-flex tw-flex-col-reverse tw-overflow-y-auto tw-px-6 tw-py-4 ${bgClass}`}
    >
      {/* Bouton charger plus (apparaît en haut grâce au flex-col-reverse du parent) */}
      {hasMore && onLoadMore && (
        <div className="tw-flex tw-justify-center tw-mb-4">
          <button
            onClick={onLoadMore}
            disabled={loadingMore}
            className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-white tw-text-gray-600 tw-border tw-border-gray-300 tw-rounded-lg hover:tw-bg-gray-50 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
          >
            {loadingMore ? (
              <>
                <RefreshCw className="tw-w-4 tw-h-4 tw-animate-spin" />
                Chargement...
              </>
            ) : (
              <>
                <ChevronUp className="tw-w-4 tw-h-4" />
                Charger plus de messages
              </>
            )}
          </button>
        </div>
      )}

      {/* Messages - flex-col-reverse sur le parent fait le scroll auto en bas */}
      {messages.map((message) => (
        <MessageItem
          key={message.id}
          message={message}
          isCurrentUser={message.user?.uuid === currentUserId}
          onAttachmentClick={onAttachmentClick}
          isBeneficiaryView={isBeneficiaryView}
        />
      ))}
    </div>
  );
}